import { Navigate, useParams } from "react-router-dom";
import { AuthContext } from "../../contexts/AuthContext";
import { useContext } from "react";

const ProtectedRouteWithUserCheck = ({ children }) => {
    const { user_id } = useParams();
    const { user } = useContext(AuthContext);

    const actualUserId = user ? (user.user_table_id ?? user.user_id) : null;

    if (!actualUserId) {
        return <Navigate to="/unauthorized" replace />;
    }

    if (Number(user_id) !== Number(actualUserId)) {
        return <Navigate to="/unauthorized" replace />;
    }

    return children;
};

export default ProtectedRouteWithUserCheck;
